module.exports = __webpack_public_path__ + "static/media/Arrow-left-bright-red.5c5e7a65.svg";